import styled from 'styled-components';

export const Form = styled.form`
  margin-top: 20px;
  width: 400px;
  display: flex;
  flex-direction: column;

  input {
    margin-bottom: 20px;
    height: 40px;
    padding: 0 10px;
    border-radius: 4px;
    border: 1px solid #ddd;
  }
  
  .erro {
    color: red;
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    font-size: 15px;
  }
`;

export const Button = styled.button`
  background: purple;
  border: none;
  border-radius: 3px;
  cursor: pointer;
  padding: 10px;
  margin: 3px;
  color: white;

  &:hover {
    background: purple;
  }
`;
